import React from "react";
import MDBox from "../../components/MDBox";
import MDButton from "../../components/MDButton";
import Card from "@mui/material/Card";
import { deleteCampaign, editAdvertisement } from "../../assets/firebaseFirestore";
import { useNavigate } from "react-router-dom";
import { Description, Info, InfoTwoTone, Note } from "@mui/icons-material";

const DeleteModal = ({ modal, setModal, getUpdate }) => {

  const navigate = useNavigate();

  const deactivate = () => {
    deleteCampaign(modal, getUpdate, setModal);
  };

  return (
    <div style={{
      width: "100vw",
      height: "100vh",
      display: "flex",
      position: "fixed",
      left: 0,
      top: 0,
      zIndex: "9999",
      alignItems: "center",
      justifyContent: "center",
    }} className="ModalLAyout">
      <div onClick={() => setModal(null)} style={{
        width: "100vw",
        height: "100vh",
        background: "#00000080",
        left: 0,
        top: 0,
        position: "absolute",
      }} className="ModalBlur"></div>
      <Card style={{
        textAlign: "center",
        padding: "1rem",
        display: "flex",
        gap: "15px",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }} className="modal-wrapper">
        <h3>Delete campaign?</h3>
        <span style={{
          marginTop: "0",
          fontSize: "14px"
        }}>If here's any linked advertisements you should delete them first</span>
        <MDBox sx={{ display: "flex", gap: "15px" }}>
          <MDButton onClick={() => deactivate()} variant={"contained"} color={"primary"}>Delete</MDButton>
          <MDButton onClick={() => setModal(null)} variant={"contained"} color={"primary"}>Cancel</MDButton>
        </MDBox>
      </Card>
    </div>
  );
};

export default DeleteModal;
